import { useContext } from 'react';
import { SecurityContext } from '../providers/SecurityProvider';

export function useAuth() {
  const {
    auth,
    user,
    loading,
    login,
    acceptInvitation,
    logout,
    reload,
    isAuthenticated,
    setUser,
  } = useContext(SecurityContext);

  if (!auth) {
    throw new Error("useAuth debe usarse dentro de SecurityProvider");
  }

  return {
    user,
    loading,
    login,
    acceptInvitation,
    logout,
    refresh: () => auth.refresh(),
    reload,
    isAuthenticated,
    setUser,

    forgotPassword: async (data) => {
      try {
        return await auth.forgotPassword(data);
      } catch (error) {
        throw error;
      }
    },

    resetPassword: async (data) => {
      try {
        return await auth.resetPassword(data);
      } catch (error) {
        throw error;
      }
    },

    activateAccount: async (hash) => {
      try {
        return await auth.activateAccount(hash);
      } catch (error) {
        throw error;
      }
    }

  };
}